import { motion } from "framer-motion";
import { Trophy, CalendarDays, Users, ShieldCheck } from "lucide-react";

const items = [
  {
    icon: Trophy,
    title: "Competitive Baseball",
    desc: "Real games, real stakes. Bring your glove and your edge — this isn't slow-pitch on a Sunday picnic.",
    span: "lg:col-span-2",
  },
  {
    icon: CalendarDays,
    title: "Weekend-Only Schedule",
    desc: "Games on weekends. No weeknight grind. Built around work, family and real life.",
    span: "",
  },
  {
    icon: Users,
    title: "Family-Friendly Atmosphere",
    desc: "Bring the kids, the partner, the cooler. The dugout welcomes everyone.",
    span: "",
  },
  {
    icon: ShieldCheck,
    title: "No Drama, No Politics",
    desc: "Just baseball. We keep it clean, fair, and about the game on the field.",
    span: "lg:col-span-2",
  },
];

export const WhyJoin = () => {
  return (
    <section id="why" data-testid="why-section" className="relative py-24 lg:py-32 bg-[#0A0A0A] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl">
          <span className="text-[#FF3B30] text-xs font-bold uppercase tracking-[0.3em]">Why Join</span>
          <h2 className="text-4xl sm:text-5xl uppercase tracking-tighter mt-4 leading-[0.95]">
            Our Goal Is Simple
          </h2>
        </div>

        <div className="mt-14 grid lg:grid-cols-3 gap-5">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <motion.div
                key={it.title}
                data-testid={`why-card-${i}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className={`group bg-[#141414] border border-white/10 p-8 hover:border-[#FF3B30]/60 transition-colors ${it.span}`}
              >
                <Icon className="text-[#FF3B30] mb-6 group-hover:scale-110 transition-transform" size={40} strokeWidth={1.5} />
                <h3 className="text-2xl uppercase tracking-tight mb-3">{it.title}</h3>
                <p className="text-[#8A94A0] font-medium leading-relaxed">{it.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
